import { createPermission } from '@backstage/plugin-permission-common';

export * from './models';
export * from './generated';

export const CONFLUENT_PERMISSION = 'confluent.connect.update';

export const CONFLUENT_ADMIN_ANNOTATION = 'velux.com/confluent-admin';

export const confluentPermission = createPermission({
  name: CONFLUENT_PERMISSION,
  attributes: { action: 'update' },
});
